export default "__VITE_ASSET__BdHm9Jyh__"